import { DetailedHTMLProps, HTMLAttributes } from 'react';
import Image from 'next/image';
import cn from 'classnames';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import styles from './lets-link-merch.module.css';

import bg from '../../public/letslink/merch/bg.jpg';
import merch from '../../public/letslink/merch/merch.png';
import {
  Container,
  Htag,
  HtagAlign,
  HtagVariant,
  Paragraph,
} from '../../components';

export interface LetsLinkMerchProps
  extends DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement> {}

export default function LetsLinkMerch({
  className,
  ...props
}: LetsLinkMerchProps) {
  return (
    <section className={cn(className, styles.merch)} {...props}>
      <Container variant="container_small">
        <AnimationOnScroll
          delay={0}
          offset={200}
          animateOnce
          duration={1.2}
          animateIn="animate__fadeInDown"
          className={styles.banner}
        >
          <Htag
            tag="h4"
            align={HtagAlign.center}
            variant={HtagVariant.h4}
            className={styles.merch_title}
          >
            company merch
          </Htag>
        </AnimationOnScroll>
        <AnimationOnScroll
          delay={0}
          offset={200}
          animateOnce
          duration={1.2}
          animateIn="animate__fadeInDown"
          className={styles.banner}
        >
          <Paragraph className={styles.merch_text}>
            While working on the Brand Identity for LinkApp project, we have
            designed the branded merch materials like t-shirt, cup, baseball cap
            and notebook.
          </Paragraph>
        </AnimationOnScroll>
      </Container>

      <div className={styles.merch_inner}>
        <Image
          alt="Linkapp background"
          layout="fill"
          objectFit="contain"
          src={bg}
        />
        <AnimationOnScroll
          delay={0}
          offset={200}
          animateOnce
          duration={1.2}
          animateIn="animate__fadeIn"
          className={styles.banner}
        >
          <Image alt="Linkapp merch" src={merch} />
        </AnimationOnScroll>
      </div>
    </section>
  );
}
